// extracted by mini-css-extract-plugin
export default {"container":"LoadingPlaceholder_container__firD4"};